import Vue from 'vue'

import { mapState } from 'vuex'
import { getFirstName } from '@/functions'

import confirmDialogMixin from '@/mixins/cd.mixin.js'

import PaymentModal from '@/modals/PaymentModal'
import SosButton from '@/components/SosButton'
import ConfirmDialog from '@/modals/ConfirmDialog'

import { getPlanDiscount, isUserPlanOld } from '@/utils.js'
import { apiActivateCoupon, apiCancelSubscription } from '@/services/users'

import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-BR')

//
//
//

export default {
  name: 'UserSubscription',

  components: {
    'payment-modal': PaymentModal,
    'sos-button': SosButton,
    'confirm-dialog': ConfirmDialog,
  },

  mixins: [
    confirmDialogMixin,
  ],

  data () {
    return {
      showSubscriptionDetailsDialog: false,

      selectedPlan: null,

      cupom: '',

      descontoAplicado: false,

      loading: false,

      anual: false,

      planos: {
        plano2: {
          key: 'plano2',
          nome: 'Plano 2',
          cupom: {
            mensal: null,
            anual: null,
          },
          old: {
            mensal: null,
            anual: null,
          },
          mensal: null,
          anual: null,
        },
        plano3: {
          key: 'plano3',
          nome: 'Plano 3',
          cupom: {
            mensal: null,
            anual: null,
          },
          old: {
            mensal: null,
            anual: null,
          },
          mensal: null,
          anual: null,
        },
        plano4: {
          key: 'plano4',
          nome: 'Plano 4',
          cupom: {
            mensal: null,
            anual: null,
          },
          old: {
            mensal: null,
            anual: null,
          },
          mensal: null,
          anual: null,
        },
        plano5: {
          key: 'plano5',
          nome: 'Plano 5',
          cupom: {
            mensal: null,
            anual: null,
          },
          old: {
            mensal: null,
            anual: null,
          },
          mensal: null,
          anual: null,
        },
      },
    }
  },

  computed: {
    ...mapState({
      userSession: state => state.app.userSession,
      plans: state => state.app.plans,
    }),

    userCapabilities: function () {
      const { userCapabilities } = this.userSession

      const cap = []

      cap.push(Number(userCapabilities.limiteEscalas) === 1 ? `${userCapabilities.limiteEscalas} escala` : `${userCapabilities.limiteEscalas} escalas`)
      cap.push(userCapabilities.limiteUsuarios === 1 ? `${userCapabilities.limiteUsuarios} pessoa por escala` : `${userCapabilities.limiteUsuarios} pessoas por escala`)
      if (userCapabilities.editorUsuarios) cap.push('Gestão de usuários')
      if (userCapabilities.folhaPagamento) cap.push('Folha de pagamento')
      if (userCapabilities.relatorioEscala) cap.push('Imprimir escala')
      if (userCapabilities.relatorioHoras) cap.push('Relatório de horas')
      if (userCapabilities.folhaDePonto) cap.push('Registro de check-in/check-out')
      if (userCapabilities.relacionarEscalas) cap.push('Relacionar escalas ao plantonista')
      if (userCapabilities.planManager) cap.push('Gestor de planos')

      return cap.length > 1 ? `${cap.slice(0, cap.length - 1).join(', ')} e ${cap[cap.length - 1]}.` : (cap.length === 1 ? `${cap[0]}.` : '')
    },

    planColorClass: function () {
      const planCategory = this.userSession.planCategory || false
      return planCategory === false ? '' : (planCategory === 'plano2' ? 'alertBronze' : (planCategory === 'plano3' ? 'alertSilver' : (planCategory === 'plano4' ? 'alertGold' : (planCategory === 'plano5' ? 'alertPlatinum' : ''))))
    },

    vindiPlanColorClass: function () {
      const planCategory = !!this.userSession.vindi === true && !!this.userSession.vindi.planCategory === true ? this.userSession.vindi.planCategory : false
      return planCategory === false ? '' : (planCategory === 'plano2' ? 'alertBronze' : (planCategory === 'plano3' ? 'alertSilver' : (planCategory === 'plano4' ? 'alertGold' : (planCategory === 'plano5' ? 'alertPlatinum' : ''))))
    },

    couponPlanColorClass: function () {
      const planCategory = !!this.userSession.coupon === true && !!this.userSession.coupon.planCategory === true ? this.userSession.coupon.planCategory : false
      return planCategory === false ? '' : (planCategory === 'plano2' ? 'alertBronze' : (planCategory === 'plano3' ? 'alertSilver' : (planCategory === 'plano4' ? 'alertGold' : (planCategory === 'plano5' ? 'alertPlatinum' : ''))))
    },

    vindiPlanStatus: function () {
      return !!this.userSession.vindi === false ? 'Inativa' : (!!this.userSession.vindi.paymentStatus === true ? (!!this.userSession.vindi.isActive === true ? 'Ativa' : 'Expirado ou Pendente') : 'Inativa')
    },

    vindiExpirationDate: function () {
      return !!this.userSession.vindi && !!this.userSession.vindi.planExpirationDate ? this.userSession.vindi.planExpirationDate : ''
    },

    couponExpirationDate: function () {
      return !!this.userSession.coupon && !!this.userSession.coupon.planExpirationDate ? this.userSession.coupon.planExpirationDate : ''
    },

    /* isUserPlanFree () {
      return this.userSession.planId === 0
    }, */

    // Senhor Jesus: Não detecta planId 0
    isVindiUserPlanOld () {
      return !!this.userSession.vindi === true && !!this.userSession.vindi.planId === true ? isUserPlanOld(Number(this.userSession.vindi.planId)) : false
    },

    /* hasCouponPlan () {
      return !!this.userSession.coupon === true
    }, */

    hasActiveCouponPlan () {
      return !!this.userSession.coupon === true && !!this.userSession.coupon.isActive === true
    },

    hasVindiPlan () {
      return !!this.userSession.vindi === true
    },

    isVindiPlanActive () {
      return !!this.userSession.vindi === true && !!this.userSession.vindi.isActive === true
    },

    isVindiUserPlanPaid () {
      return !!this.userSession.vindi === true && this.userSession.vindi.paymentStatus === 'paid'
    },

    isVindiUserPlanPending () {
      return !!this.userSession.vindi === true && this.userSession.vindi.paymentStatus === 'pending'
    },

    userFirstName: function () {
      return getFirstName(this.userSession.userProfile.nome)
    },

    couponLength: function () {
      return this.cupom.trim().length
    },
  },

  watch: {
    '$store.state.app.plans': {
      deep: true,
      immediate: true, // the callback will be called immediately after the start of the observation
      handler (newPlans, oldPlans) {
        // [24/01/25] console.log('newPlans:', newPlans, oldPlans)

        if (newPlans.length > 0) this.setPlans()
      },
    },
  },

  methods: {
    openCancelationDialog: function () {
      this.showConfirmBox({ title: 'Atenção!', text: 'Você deseja cancelar o seu plano atual?', type: 'cancelPlan', data: '', isResponse: false, buttonPosition: 'right', width: 330, closeText: 'Não', continueText: 'Sim, quero cancelar!' })
    },

    async cdAction (cdResponse)
    {
      if (cdResponse === false) return

      //
      //
      //

      if (cdResponse.cdType === 'cancelPlan')
      {
        // [24/01/25] console.log('::: DIALOG RESPONSE > cancelPlan > userToken:', this.$store.state.app.userSession.userToken)

        // this.cancelDialog = false

        this.loading = true
        const response = await apiCancelSubscription({}, this.$store.state.app.userSession.userToken)
        this.loading = false

        if (response.code === 1 && !!response.pay.canceled === true) {
          this.showDialog(response.title, response.message, 'refreshPage', '', true, 'right', 400, true)
        } else {
          this.showMessage(response.title, response.message)
        }
      }

      //
      //
      //

      if (cdResponse.cdType === 'refreshPage')
      {
        document.location.reload()
      }
    },

    openSubscriptionDetailsDialog: function () {
      this.showSubscriptionDetailsDialog = true
    },

    openOldVindiPlanDetailsDialog: function () {
      this.showMessage('Atenção!', `Agora o seu ${this.getUserVindiPlanOldName()} é Plano ${this.getUserVindiPlanNewName()}, mas você continua pagando o valor de ${this.getUserVindiPlanOldPrice()} até o cancelamento da sua assinatura.<br /><br />As funções de Impressão da escala, Relatório de horas e Espelho de ponto continuam disponíveis.<br /><br />Qualquer dúvida&nbsp;<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, sou assinante do ${this.userSession.vindi.planName.name} e gostaria de tirar algumas dúvidas." target="_blank">fale com o nosso suporte</a>.`)
    },

    getUserVindiPlanOldPrice () {
      if (!!this.userSession.vindi.planId === false || !!this.userSession.vindi.planCategory === false || !!this.plans === false || !!this.planos === false) return ''

      const plan = this.plans.find(plan => Number(plan.id) === Number(this.userSession.vindi.planId))
      if (!!plan === false) return ''

      const intervalCount = plan.interval_count
      const interval = intervalCount === 12 ? 'anual' : (intervalCount === 1 ? 'mensal' : '')
      const intervalName = intervalCount === 12 ? 'ano' : (intervalCount === 1 ? 'mês' : '')
      const price = /* this.anual */ interval === 'anual' ? this.planos[this.userSession.vindi.planCategory].old.anual.price : this.planos[this.userSession.vindi.planCategory].old.mensal.price

      return price.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }) + '/' + intervalName // .replace(/(?:[\s]|[\R\$]+)+/g, '')
    },

    planoOriginalPrice: function (plano) {
      if (!!this.planos[plano].mensal === false) return 'R$ 0,00'

      const mensalPrice = this.descontoAplicado && !this.anual ? this.planos[plano].mensal.price : (this.planos[plano].mensal.price * 12)

      // eslint-disable-next-line
      const price = mensalPrice.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }).replace(/(?:[\s]|[\R\$]+)+/g, '')

      // [24/01/25] console.log('::: planoOriginalPrice:', plano, this.planos[plano], price)

      return price
    },

    planoPrice: function (plano) {
      if ((!this.anual && !!this.planos[plano].mensal === false) || (this.anual && !!this.planos[plano].anual === false)) return 'R$ 0,00'

      const objMensal = this.descontoAplicado ? this.planos[plano].cupom.mensal : this.planos[plano].mensal
      const objAnual = this.descontoAplicado ? this.planos[plano].cupom.anual : this.planos[plano].anual

      let price

      if (this.anual) {
        // eslint-disable-next-line
        price = objAnual.price.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }).replace(/(?:[\s]|[\R\$]+)+/g, '') // .replace(' ', '').replace('$', '').replace('R', '')
      } else {
        // eslint-disable-next-line
        price = objMensal.price.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }).replace(/(?:[\s]|[\R\$]+)+/g, '') // .replace(' ', '').replace('$', '').replace('R', '')
      }

      // [24/01/25] console.log('::: planoPrice:', plano, price)

      return price
    },

    checkUserPlan: function (plano) {
      return this.userSession.planCategory === plano
    },

    getUserVindiPlanOldName () {
      if (!!this.userSession.vindi === false || !!this.userSession.vindi.planId === false || !!this.userSession.vindi.planCategory === false || !!this.plans === false || !!this.planos === false) return ''

      const plan = this.plans.find(plan => Number(plan.id) === Number(this.userSession.vindi.planId))
      if (!!plan === false) return ''

      const intervalCount = plan.interval_count
      const interval = intervalCount === 12 ? 'anual' : (intervalCount === 1 ? 'mensal' : '')
      const oldName = /* this.anual */ interval === 'anual' ? this.planos[this.userSession.vindi.planCategory].old.anual.name : this.planos[this.userSession.vindi.planCategory].old.mensal.name

      return oldName.replace(' Anual', '').replace(' Mensal', '')
    },

    getUserVindiPlanNewName () {
      if (!!this.userSession.vindi === false || !!this.userSession.vindi.planId === false || !!this.userSession.vindi.planCategory === false || !!this.plans === false || !!this.planos === false) return ''

      const plan = this.plans.find(plan => Number(plan.id) === Number(this.userSession.vindi.planId))
      if (!!plan === false) return ''

      const intervalCount = plan.interval_count
      const interval = intervalCount === 12 ? 'anual' : (intervalCount === 1 ? 'mensal' : '')
      const newName = /* this.anual */ interval === 'anual' ? this.planos[this.userSession.vindi.planCategory].anual.name : this.planos[this.userSession.vindi.planCategory].mensal.name

      return newName.replace(' Anual', '').replace(' Mensal', '')
    },

    getUserVindiPlanDiscount () {
      if (!!this.userSession.vindi === false || !!this.userSession.vindi.planId === false || !!this.plans === false) return ''

      const planDiscount = getPlanDiscount(Number(this.userSession.vindi.planId))
      const planDiscountName = planDiscount === 0 ? '' : (planDiscount + '%')

      return planDiscountName
    },

    getUserVindiPlanPrice (withDiscount = true) {
      if (!!this.userSession.vindi === false || !!this.userSession.vindi.planId === false || !!this.plans === false) return ''

      const plan = this.plans.find(plan => Number(plan.id) === Number(this.userSession.vindi.planId))
      if (!!plan === false) return ''

      const intervalName = plan.interval_count === 12 ? 'ano' : (plan.interval_count === 1 ? 'mês' : '')
      const planDiscount = getPlanDiscount(Number(this.userSession.vindi.planId))
      const planDiscountName = planDiscount === 0 || withDiscount === false ? '' : (' (com ' + planDiscount + '% de desconto)')

      // .replace(/(?:[\s]|[\R\$]+)+/g, '')
      return plan.price.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }) + ' por ' + intervalName + planDiscountName
    },

    setPlans () {
      this.plans.forEach(plan => {
        // console.log(plan)
        let interval

        const isOld = plan.id < 9
        const isCupom = plan.id >= 17

        if (plan.interval_count === 12) {
          interval = 'anual'
        } else if (plan.interval_count === 1) {
          interval = 'mensal'
        } else {
          return
        }

        // [24/01/25] console.log('[' + (isOld ? 'old' : 'new') + '] ' + 'PLANO', plan.category, interval, plan)

        if (isOld) {
          this.planos[plan.category].old[interval] = plan
        } else {
          if (!isCupom) {
            this.planos[plan.category][interval] = plan
          } else {
            this.planos[plan.category].cupom[interval] = plan
          }
        }
      })

      // [24/01/25] console.log('Planos:', this.planos)
    },

    cancelCoupon () {
      this.descontoAplicado = false
      this.cupom = ''
    },

    async applyCoupon ()
    {
      if (this.loading) return false

      const coupon = this.cupom.trim()

      if (coupon.length === 0) return this.showMessage('Atenção!', 'Informe o código do cupom')

      //
      //
      //

      this.loading = true
      const response = await apiActivateCoupon({ coupon }, this.$store.state.app.userSession.userToken)
      this.loading = false

      if (response.code !== 1) return this.showMessage(response.title, response.message)

      this.cupom = ''

      if (response.discountActivated === true) this.descontoAplicado = true

      if (response.reload === true) {
        this.showDialog(response.title, response.message, 'refreshPage', '', true, 'right', 400, true)
      } else {
        this.showMessage(response.title, response.message)
      }
    },

    selectPlan (plano) {
      // Redireciona para o WhatsApp quando o botão "Selecionar" for clicado
      const whatsappUrl = 'https://api.whatsapp.com/send/?phone=5513992061010&text=Preciso+de+ajuda+para+melhorar+minha+escala&type=phone_number&app_absent=0'
      window.open(whatsappUrl, '_blank')

      // Código original comentado para manter a funcionalidade anterior se necessário
      // const objMensal = this.descontoAplicado ? this.planos[plano].cupom.mensal : this.planos[plano].mensal
      // const objAnual = this.descontoAplicado ? this.planos[plano].cupom.anual : this.planos[plano].anual

      // [24/01/25] console.log('::: SELECT PLAN:', plano)

      // this.selectedPlan = this.anual ? objAnual : objMensal
    },

    clearPlan () {
      this.selectedPlan = null
    },
  },
}
